import { Component, OnInit } from '@angular/core';
import { Lifecycle } from '../../../../_helpers/Lifecycle/Lifecycle.class';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
//import { CategoryEditModalComponent } from '../category/category-edit-modal/category-edit-modal.component';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { Constants } from '../../../../_utils/Constants';

@Component({
  selector: 'app-hometsp',
  templateUrl: './hometsp.component.html',
  styleUrls: ['./hometsp.component.css']
})
export class HometspComponent implements OnInit {   

   constructor(
    private db: $DBManagerService,
    private evt: $BroadcastManagerService
  ) { }

  ngOnInit(): void {
    this.db.clearDB();
    this.evt.emit({ 'click': 'HEADER_EVENT' });
  }

}
